import * as React from 'react';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';

export default function RequestPagination({page,setPage,count}) {
  const handleChange = (event, value) => {
    setPage(value);
  };

  return (
    <Stack spacing={2} mt={1} >
      <Pagination count={count} page={page} onChange={handleChange} />
    </Stack>
  );
}
